"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { key: 0 };
const _hoisted_2 = ["value"];
const _hoisted_3 = { key: 0 };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_select_player_row = (0, vue_1.resolveComponent)("select-player-row");
    const _component_AppButton = (0, vue_1.resolveComponent)("AppButton");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", null, [
        (_ctx.showtitle === true)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, (0, vue_1.toDisplayString)(_ctx.$t(_ctx.playerinput.title)), 1))
            : (0, vue_1.createCommentVNode)("", true),
        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)((_ctx.playerinput.players || []), (player) => {
            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("label", {
                key: player,
                class: "form-radio form-inline"
            }, [
                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                    type: "radio",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedPlayer) = $event)),
                    value: player
                }, null, 8, _hoisted_2), [
                    [vue_1.vModelRadio, _ctx.selectedPlayer]
                ]),
                _cache[1] || (_cache[1] = (0, vue_1.createElementVNode)("i", { class: "form-icon" }, null, -1)),
                (player === 'NEUTRAL')
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_3, "Neutral"))
                    : ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_select_player_row, {
                        key: 1,
                        player: _ctx.players.find((otherPlayer) => otherPlayer.color === player)
                    }, null, 8, ["player"]))
            ]));
        }), 128)),
        (_ctx.showsave === true)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_AppButton, {
                key: 1,
                size: "big",
                onClick: _ctx.saveData,
                title: _ctx.$t(_ctx.playerinput.buttonLabel)
            }, null, 8, ["onClick", "title"]))
            : (0, vue_1.createCommentVNode)("", true)
    ]));
}
